<script>
const httpUrl = process.env.VUE_APP_BASE_URL

export default {
    httpUrl
}
</script>

